export class ListModel<T> {
  loading: boolean;
  list: T[];
  itemCount: number;
  path?: string;
  filter?: any;
  attributes?: any;
  promise?: any;
  stats?: any;
}
